<template>
    <span v-if="alim == null || alim == 'undefined'">
        _
    </span>
    <span v-else-if="alim >= 7" class="ui-badge status-badge--ok">
        <font-awesome-icon :icon="['fas', 'plug']" class="me-1"/> {{ alim }} v
    </span>
    <span v-else-if="alim < 7" class="ui-badge status-badge--medium">
        <font-awesome-icon :icon="['fas', 'plug']" class="me-1"/> {{ alim }} v
    </span>
    <span v-else>
        {{ alim }}
    </span>
</template>

<script>
export default {
  props: ['alim']
}
</script>